<template>
  <FormItem :prop="prop">
    <span class="avatar">
      <Avatar
        icon="android-person"
        size="small"
        color="#e0e0e0"
      />
    </span>
    <Input
      v-model="val"
      placeholder="身分證字號"
      size="large"
      type="text"
    />
  </FormItem>
</template>

<script>
  import { FormItem, Input, Avatar } from 'iview';

  export default {
    components: { FormItem, Input, Avatar },
    props: {
      prop: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      }
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>
